/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Noaccountsdesc2Inputs */

const zh_linked_noaccountsdesc2 = /** @type {(inputs: Linked_Noaccountsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您可以绑定第三方账号以便快速登录。`)
};

const en_linked_noaccountsdesc2 = /** @type {(inputs: Linked_Noaccountsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can link third-party accounts for quick sign-in.`)
};

const es_linked_noaccountsdesc2 = /** @type {(inputs: Linked_Noaccountsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes vincular cuentas de terceros para iniciar sesión rápidamente.`)
};

/**
* | output |
* | --- |
* | "You can link third-party accounts for quick sign-in." |
*
* @param {Linked_Noaccountsdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const linked_noaccountsdesc2 = /** @type {((inputs?: Linked_Noaccountsdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Noaccountsdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linked_noaccountsdesc2(inputs)
	if (locale === "en") return en_linked_noaccountsdesc2(inputs)
	return es_linked_noaccountsdesc2(inputs)
});
export { linked_noaccountsdesc2 as "linked_noAccountsDesc" }